// Column limits of the API, so a too long value fails in the form instead of as a
// 500 from Postgres on save. The client hit this with a shared code
// "Saisonkarte vorweisen" (21 characters) against voucher.voucher_code varchar(20):
// the whole reward failed to be created and the error was unreadable.
//
// Keep in sync with the entities: RewardEntity.name / popup_title,
// VoucherEntity.voucher_code / order_id. Fields stored as text (description,
// popup_text, redeem_description, image_url, sponsor_link) have no limit.
const fieldLengths = {
    name: 140,
    popup_title: 120,
    shared_code: 20,
    order_id: 10,
};

export const maxLengthRule = (name) =>
    fieldLengths[name] && {
        value: fieldLengths[name],
        message: `Maximal ${fieldLengths[name]} Zeichen`,
    };

export default fieldLengths;
